#import "../fragments/edition-dashboard-fragment.graphql"
#import "../fragments/dashboard-stats-fragment.graphql"

query GetEditionsDashboard($input: DashboardInput!) {
    editionsDashboard(input: $input) {
        stats {
            ...DashboardStatsFragment
        }
        recentEditions {
            ...EditionDashboardFragment
        }
        scheduledEditions {
            id
            name
            htmlUrlPath
            scheduledTime
        }
        draftEditions {
            id
            name
            htmlUrlPath
            modifiedTime
        }
        totalCount
    }
}
